import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledBox = styled(Box)(({ theme }) => ({
  padding: "12px 24px 8px 24px",
  marginBottom: theme.spacing(1),
}));

export interface IPageTitleProps {
  title: string;
  image?: string | null;
  subtitle?: string;
  children?: React.ReactNode; // For additional content like buttons, sync icons, etc.
}

const PageTitle: React.FC<IPageTitleProps> = ({
  title,
  image,
  subtitle,
  children,
}) => {
  return (
    <StyledBox id="gridTitle" className="page-header">
      <Box
        alignItems="flex-start"
        justifyContent="flex-start"
        sx={{ display: "flex", flexDirection: "column", width: "100%" }}
      >
        {image && (
          <img
            src={image}
            style={{
              width: "48px",
              height: "48px",
              margin: "2px 12px 2px 2px",
            }}
          />
        )}
        <Typography variant="h3">{title}</Typography>
        {subtitle && (
          <Typography variant="body1" color="textSecondary">
            {subtitle}
          </Typography>
        )}
        {children && <Grid>{children}</Grid>}
      </Box>
    </StyledBox>
  );
};

export default PageTitle;
